import { BrowserRouter, Route, Routes } from "react-router";
import Landing from "./pages/Landing";
import SplashScreen from "./pages/SplashScreen";
import Dashboard from "./pages/Dashboard";

function App() {
  return (
    <BrowserRouter>
     <Routes>
       <Route path="/" element={<SplashScreen />} />
       <Route path="/home" element={ <Landing />} />
       <Route path="/dashboard" element={ <Dashboard />} />
     </Routes>
    </BrowserRouter>
  );
}

export default App;
